<template>
  <span v-on="$listeners" class="app-action-button">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'AppActionButton',
}
</script>

<style scoped>
.app-action-button {
  display: inline-block;
  font-size: 14px;
  color: var(--c-primary);
  border-radius: 4px;
  background-color: var(--c-secondary-400);
  padding: 8px 20px;
  margin-top: 10px;
  max-width: max-content;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.app-action-button:hover {
  background-color: var(--c-secondary-500);
}
</style>
